import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/sonner";
import { Activity, Loader2 } from "lucide-react";

export const PublicStatsCard = () => {
  const { t } = useTranslation();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/public-stats").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  if (!s) return null;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/public-stats", { placed_offset: Number(s.placed_offset) || 0, companies_offset: Number(s.companies_offset) || 0 });
      setS(data);
      toast.success(t("admin.counterSaved"));
    } catch {
      toast.error(t("admin.counterError"));
    } finally {
      setBusy(false);
    }
  };
  const row = (k, live, label, testId) => (
    <div>
      <Label htmlFor={k}>{label}</Label>
      <Input id={k} type="number" min="0" value={s[k]} onChange={set(k)} className="mt-1.5" data-testid={testId} />
      <p className="mt-1 text-xs text-slate-500">{t("admin.counterLive", { live, total: live + (Number(s[k]) || 0) })}</p>
    </div>
  );
  return (
    <Card className="mb-10 border-slate-200 p-6" data-testid="public-stats-card">
      <div className="flex items-center gap-2">
        <Activity className="h-5 w-5 text-rose-600" />
        <h2 className="font-heading text-lg font-bold text-slate-900">{t("admin.counterTitle")}</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">{t("admin.counterHelp")}</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-[1fr_1fr_auto] sm:items-start">
        {row("placed_offset", s.live_placed, t("admin.counterPlaced"), "counter-placed-offset")}
        {row("companies_offset", s.live_companies, t("admin.counterCompanies"), "counter-companies-offset")}
        <Button onClick={save} disabled={busy} className="mt-6 bg-amber-600 hover:bg-amber-700" data-testid="counter-save">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} {t("admin.counterSave")}
        </Button>
      </div>
    </Card>
  );
};
